import { FC } from 'react';

import { observer } from 'mobx-react';

import { formatDate } from 'utils/DateUtils';

import { OralReportV3, OralQuestionTypeV3 } from 'models/OralReport/OralReportV3';

import { useOralReportCycle } from 'hooks/useOralReportCycle';

import LabelDatePicker from 'components/DateTimePicker/LabelDateTimePicker';
import { OralReportCycleProps } from 'components/Ticket/TicketRow/OralReport/OralReport.shared';

export const OralReportCycleV3: FC<OralReportCycleProps<OralReportV3>> = observer(
  ({ reportId, oral, patient }) => {
    const { startOfCycleDate } = oral;
    const startOfCycle = oral[OralQuestionTypeV3.StartOfCycle];
    const { selectedDate, handleDateSelect } = useOralReportCycle(
      patient,
      reportId,
      startOfCycleDate
    );

    if (startOfCycle?.isAnswered) {
      return <span>{formatDate(startOfCycle.value!, 'MMMM D, YYYY')}</span>;
    }

    return (
      <LabelDatePicker date={selectedDate} onSelect={handleDateSelect} placeholder="Unknown" />
    );
  }
);
